import React from 'react';
import startCase from 'lodash/startCase';
import { compose } from 'recompose';
import styled, { StylesProps, cx } from '../../../../../../../lib/styles';
import Spacer from '../../../../../../../components/presentational/Spacer';
import { CustomCard } from '../../CardBlock';
import customFeatureStyles from './CustomFeature_styles';
import Image from '../../../../../../../components/presentational/Image';

export interface CustomFeatureProps {
  card: CustomCard;
  onClick?: () => any;
  lazy: boolean;
}

const CustomFeature = ({
  onClick,
  card: {
    category,
    highlight,
    hoverText,
    image,
    link,
    ribbonText,
    text,
    title,
  },
  lazy = true,
  styles,
}: CustomFeatureProps & StylesProps<typeof customFeatureStyles>) => (
  <a className={styles.link} href={link} onClick={onClick}>
    <div className={styles.featureContainer}>
      <div className={styles.featureImageContainer}>
        <Image
          alt={title}
          className={cx(styles.featureImage, 'CustomFeature__image')}
          src={image}
          lazy={lazy}
          aspect={[16, 9]}
          resizeWidth={760}
          resizeFit={'crop'}
        />
        <div className={styles.imageBackground}>
          <button>{hoverText || 'Read more'}</button>
        </div>
        {ribbonText && <div className={styles.tag}>{ribbonText}</div>}
      </div>
      <Spacer className={styles.featuretext} space={'xxs'} align={'flex-start'}>
        <span className={styles.category}>
          {startCase(category.toLowerCase())}
        </span>
        <h2 className={cx(styles.featuretitle, 'CustomFeature__title')}>
          {title}
        </h2>

        {highlight && (
          <Spacer className={styles.highlight} selfV={'xxxs'} selfH={'xxs'}>
            {highlight}
          </Spacer>
        )}

        <Spacer space={'xs'} align={'flex-start'}>
          <span
            className={styles.subtitle}
            dangerouslySetInnerHTML={{ __html: text }}
          />
        </Spacer>
      </Spacer>
    </div>
  </a>
);

export default compose(styled(customFeatureStyles))(CustomFeature);
